<template>
  <div class="w-full">
    <Header v-if="layoutShow" :size="screenSize" :dark="home" />
    <Toast />

    <main :class="mainClasses">
      <RouterView />
    </main>

    <Footer v-if="layoutShow" :size="screenSize" :dark="home" />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import Header from '@/shared/ui/components/navigation/Header.vue'
import Footer from '@/shared/ui/components/navigation/Footer.vue'
import Toast from '@/shared/ui/components/Toast.vue'
import { useRoute } from 'vue-router'
import { computed, onBeforeMount, onBeforeUnmount, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { setDefaultLanguage } from '@/features/change-language/lib/i18n'
import { useScreenStore } from '@/shared/model/screen.store'
import { storeToRefs } from 'pinia'

const route = useRoute()
const { locale } = useI18n()
const screenStore = useScreenStore()
const { screenSize } = storeToRefs(screenStore)

const home = computed(() => route.name === 'home')

onBeforeMount(async () => {
  locale.value = setDefaultLanguage()
})

onMounted(async () => {
  setupScreenResize()
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})

const setupScreenResize = () => {
  screenStore.setScreenSize(window.innerWidth)
  window.addEventListener('resize', handleResize)
}

const handleResize = () => {
  screenStore.setScreenSize(window.innerWidth)
}

const layoutShow = computed(() => {
  return !route.meta.hideHeader
})
const padding = computed(() => {
  return !!route.meta.padding
})

const mainClasses = computed(() => {
  const base = 'flex flex-col items-center'
  const layoutMap: Record<string, string> = {
    md: layoutShow.value
      ? home.value
        ? 'min-h-[calc(100vh-200px)]'
        : 'mt-[55px] min-h-[calc(100vh-200px)]'
      : '',
    lg: layoutShow.value
      ? home.value
        ? 'min-h-[calc(100vh-200px)]'
        : 'mt-40 min-h-[calc(100vh-200px)]'
      : ''
  }
  return [base, layoutMap[screenSize.value], { 'p-6': padding.value }]
})
</script>
